import React, { CSSProperties, useEffect, useState } from 'react'
import { getProfilePictureByUserId } from '../../../utils/requestsUtils/functionsRequests/user/userFunctions'
import { userImageCache } from '../../../utils/cache/imgUserCache'
import { StageBugReport } from '../../../utils/dbModels'
import { resolveUserStage } from '../../../utils/userStage'

type UserImageProps = {
    userId: string
    sizeImg: number
    unit: string
    size?: "small" | "mid" | ""
    stage?: StageBugReport
    style?: CSSProperties
}

const UserImage = ({ userId, size = "small", sizeImg, unit, stage }: UserImageProps) => {
    
    const [imgUrl, setImgUrl] = useState("")
    const [triedOwnStage, setTriedOwnStage] = useState(false)

    useEffect(() => {

        setTriedOwnStage(false)

        const getData = async() => {

            try {
                // same call as the user cards of the bug report: the image is asked directly with the stage
                // the user can be of another stage than the bug report, so the stage where it exists is searched
                const userStage = stage ? ((await resolveUserStage(userId, stage)) ?? stage) : undefined
                const url = userStage
                    ? await getProfilePictureByUserId(userId, size, userStage)
                    : await userImageCache.getUrl(userId, size)
                setImgUrl(url)

            } catch (error) {
                console.log("Error v", error)
            }
        }

        getData()

    }, [userId, stage])
    

    return (
        <img 
            style={{
                width: `${sizeImg}${unit}`,
                height: `${sizeImg}${unit}`,
            }}
            className={"circle"} 
            src={imgUrl} 
            alt="user" 
            onError={(e) => { 
                const img = e.target as HTMLImageElement
                // the user can be of the stage of whoever did the action, not of the stage of the bug report
                if(stage && !triedOwnStage){
                    setTriedOwnStage(true)
                    userImageCache.getUrl(userId, size)
                    .then((url) => { url ? setImgUrl(url) : (img.src = "/assets/images/profilePic.png") })
                    return
                }
                img.src = "/assets/images/profilePic.png" }
            }
        />
    )
}

export default React.memo( UserImage )